import React, { Component } from 'react';
import { IPayByWebGridProps } from '../../types/propTypes/propTypes';
import { IPayByWebGridState } from '../../types/stateTypes/stateTypes';
import { IChargeStationDetailsForPayByWebList } from '../../models/charge-station';
import { IChargeStationDetailsForPayByWeb } from '../../models/charge-station';
import { Common } from '../../utils/constants';
import ability, { Can } from '../../ability';
import CommonService from '../../services/common/common-service';
import StandardResponse from '../../models/standard-response';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { trimString } from '../../utils';
import Table from '../../components/table/Table';
import ChargeStationService from '../../services/charge-station/charge-station-service';
import { ConfirmBox } from '../../components/confirm-box/ConfirmBox';
import { Modal } from 'react-bootstrap';
import { Field, Formik } from 'formik';
import { ManageUniqueCodeValidationSchema } from '../../validation/pay-by-web/pay-by-web-validation';
import { ReactstrapInput, SelectBox } from '../../components/reactstrap-formik';
import images from '../../assets/images/index';

class PayByWebGrid extends Component<IPayByWebGridProps, IPayByWebGridState> {
    private commonService: CommonService;
    private chargeStationService: ChargeStationService;
    private statusList: Array<any> = [];
    constructor(props: IPayByWebGridProps) {
        super(props);
        this.state = {
            payByWebChargeStationRequestList: [],
            columns: [],
            currentPage: 1,
            offset: 0,
            rowsPerPage: 10,
            sortColumn: 'created_date',
            sortOrder: 'desc',
            totalCount: 0,
            search: {
                search_evse_id: '',
                search_status: [],
                search_physical_reference: '',
                search_location_name: '',
                search_location_address: '',
            },
            searchForm: {
                search_evse_id: '',
                search_status: [],
                search_physical_reference: '',
                search_location_name: '',
                search_location_address: '',
            },
            modal: {
                showModal: false,
                header: '',
                body: '',
                callBack: null,
            },
            requestDetails: '',
            checkedRecord: [],
            showManageUniqueCodeModal: false,
            selectedRecordForManageCode: null,
            manageUniqueCodeForm: {
                unique_code: '',
            },
        };
        this.commonService = new CommonService();
        this.chargeStationService = new ChargeStationService();
    }
    async componentDidMount() {
        const { t } = this.props;
        this.statusList = (await this.chargeStationService.getChargeStationStatus()).Data || [];
        this.statusList = this.statusList.map((item) => {
            item = Object.assign(item, { label: item.name, value: item.code });
            return item;
        });
        const header = [
            {
                label: t('payByWeb.columns.evse_id'),
                id: 'evse_id',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 250, wordWrap: 'break-word' }}
                            title={row.evse_id}
                        >
                            {row.evse_id}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.status'),
                id: 'status',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 100, wordWrap: 'break-word' }}
                            title={row.status}
                        >
                            {row.status}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.physical_reference'),
                id: 'physical_reference',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 150, wordWrap: 'break-word' }}
                            title={row.physical_reference}
                        >
                            {row.physical_reference}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.location_name'),
                id: 'location_name',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 150, wordWrap: 'break-word' }}
                            title={row.location_name}
                        >
                            {row.location_name}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.location_address'),
                id: 'location_address',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 200, wordWrap: 'break-word' }}
                            title={row.location_address}
                        >
                            {row.location_address}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.location_city'),
                id: 'location_city',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 100, wordWrap: 'break-word' }}
                            title={row.location_city}
                        >
                            {row.location_city}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.location_postal_code'),
                id: 'location_postal_code',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 100, wordWrap: 'break-word' }}
                            title={row.location_postal_code}
                        >
                            {row.location_postal_code}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.pay_by_web_active'),
                id: 'pay_by_web_active',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span
                            className={`badge ${row.pay_by_web_active ? 'badge-success' : 'badge-danger'}`}
                            title={row.pay_by_web_active ? t('payByWeb.label.enabled') : t('payByWeb.label.disabled')}
                        >
                            {row.pay_by_web_active ? t('payByWeb.label.enabled') : t('payByWeb.label.disabled')}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.label.uniqueCode'),
                id: 'unique_code',
                sortable: true,
                isVisible: true,
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <span className="d-block text-nowrap-normal text-center" title={row.unique_code}>
                            {row.unique_code || '-'}
                        </span>
                    );
                },
            },
            {
                label: t('payByWeb.columns.action'),
                id: 'action',
                sortable: false,
                isVisible: ability.can(Common.Actions.CAN_UPDATE, Common.Modules.PAY_BY_WEB),
                style: { padding: '30px', textAlign: 'center' },
                cell: (row: IChargeStationDetailsForPayByWeb) => {
                    return (
                        <>
                            <a
                                className="icon pointer"
                                title={t('payByWeb.label.manageUniqueCode')}
                                onClick={() => this.manageUniqueCode(row)}
                            >
                                <img
                                    src={images.settingsgreySVG}
                                    alt={t('payByWeb.label.manageUniqueCode')}
                                    style={{ height: '20px', width: '20px' }}
                                />
                            </a>
                        </>
                    );
                },
            },
        ];

        this.setState(
            {
                columns: header,
            },
            () => {
                this.syncSearch().then(async () => {
                    const payByWebChargeStationRequestList = await this.getPayByWebChargeStationList();
                    this.setState({ ...this.state, payByWebChargeStationRequestList });
                });
            },
        );
    }

    syncSearch = (): Promise<boolean> => {
        return new Promise((resolve) => {
            const { search, searchForm } = this.state;
            search.search_evse_id = !_.isEmpty(searchForm.search_evse_id) ? trimString(searchForm.search_evse_id) : '';
            search.search_location_address = !_.isEmpty(searchForm.search_location_address)
                ? trimString(searchForm.search_location_address)
                : '';
            search.search_location_name = !_.isEmpty(searchForm.search_location_name)
                ? trimString(searchForm.search_location_name)
                : '';
            search.search_physical_reference = !_.isEmpty(searchForm.search_physical_reference)
                ? trimString(searchForm.search_physical_reference)
                : '';
            search.search_status = [];
            if (_.isArray(searchForm.search_status)) {
                searchForm.search_status.forEach((item) => {
                    search.search_status.push((item as any).value);
                });
            }

            this.setState({ search }, async () => {
                resolve(true);
            });
        });
    };
    getPayByWebChargeStationList = async () => {
        const { search } = this.state;
        let payByWebChargeStationRequestList: Array<IChargeStationDetailsForPayByWeb> = [];
        const filterInput = _.pickBy(search, (value) => {
            return !_.isEmpty(value);
        });
        Object.assign(filterInput, {
            limit: this.state.rowsPerPage,
            offset: this.state.offset,
            order: [[this.state.sortColumn, this.state.sortOrder]],
        });
        await this.chargeStationService
            .getPayByWebChargeStation(filterInput)
            .then(async (res: StandardResponse<IChargeStationDetailsForPayByWebList>) => {
                payByWebChargeStationRequestList = res.Data.rows;
                this.setState({ totalCount: res.Data.count });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });

        return payByWebChargeStationRequestList;
    };
    handleChange = (event) => {
        const { searchForm } = this.state;
        this.setState({
            searchForm: {
                ...searchForm,
                [event.target.name]: event.target.value,
            },
        });
    };
    handleChangeDropdown = (name, value) => {
        const { searchForm } = this.state;
        this.setState({
            searchForm: {
                ...searchForm,
                [name]: value,
            },
        });
    };
    handleSearch = () => {
        this.setState(
            {
                offset: 0,
                currentPage: 1,
            },
            () => {
                this.syncSearch().then(async () => {
                    const payByWebChargeStationRequestList = await this.getPayByWebChargeStationList();
                    this.setState({ ...this.state, payByWebChargeStationRequestList });
                });
            },
        );
    };

    handleReset = async () => {
        const searchForm = {
            search_evse_id: '',
            search_status: [],
            search_physical_reference: '',
            search_location_name: '',
            search_location_address: '',
        };
        this.setState(
            {
                ...this.state,
                searchForm,
                offset: 0,
                currentPage: 1,
            },
            () => {
                this.syncSearch().then(async () => {
                    const payByWebChargeStationRequestList = await this.getPayByWebChargeStationList();
                    this.setState({ ...this.state, payByWebChargeStationRequestList });
                });
            },
        );
    };
    handlePageChange = async (currentPage: number, rowsPerPage: number) => {
        const offset = (currentPage - 1) * rowsPerPage;
        this.setState(
            {
                currentPage: currentPage,
                rowsPerPage: rowsPerPage,
                offset: offset,
            },
            () => {
                this.syncSearch().then(async () => {
                    const payByWebChargeStationRequestList = await this.getPayByWebChargeStationList();
                    this.setState({ ...this.state, payByWebChargeStationRequestList });
                });
            },
        );
    };

    handleModal = (body: string, header: string, callBack: Function) => {
        this.setState({
            modal: {
                body: body,
                header: header,
                callBack: callBack,
                showModal: !this.state.modal.showModal,
            },
        });
    };

    handleSorting = async (columnName: string) => {
        let sortOrder = this.state.sortOrder;
        if (this.state.sortColumn === columnName) {
            sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
        } else {
            sortOrder = 'asc';
        }

        this.setState(
            {
                sortOrder: sortOrder,
                sortColumn: columnName,
            },
            () => {
                this.syncSearch().then(async () => {
                    const payByWebChargeStationRequestList = await this.getPayByWebChargeStationList();
                    this.setState({ ...this.state, payByWebChargeStationRequestList });
                });
            },
        );
    };

    manageUniqueCode = async (row) => {
        this.setState({
            showManageUniqueCodeModal: true,
            selectedRecordForManageCode: row,
            manageUniqueCodeForm: { unique_code: row.unique_code || '' },
        });
    };

    closeManageUniqueCodeModal = () => {
        this.setState({ showManageUniqueCodeModal: false, selectedRecordForManageCode: null });
    };

    onConfirmSaveUniqueCode = async (values) => {
        const obj = {
            unique_code: values.unique_code,
        };
        let chargeStationID = null;
        if (this.state.selectedRecordForManageCode) {
            chargeStationID = this.state.selectedRecordForManageCode.id;
        }
        await this.chargeStationService
            .saveUniqueCode(chargeStationID!, obj)
            .then(async (res: StandardResponse<number>) => {
                toast.success(res.Messages);
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        this.setState(
            {
                showManageUniqueCodeModal: false,
                selectedRecordForManageCode: null,
            },
            () => {
                this.syncSearch().then(async () => {
                    const payByWebChargeStationRequestList = await this.getPayByWebChargeStationList();
                    this.setState({ ...this.state, payByWebChargeStationRequestList });
                });
            },
        );
    };
    updatePayByWebChargeStation = async (pay_by_web_active: boolean) => {
        await this.chargeStationService
            .updatePayByWebChargeStation(this.state.checkedRecord, pay_by_web_active)
            .then(async (res: StandardResponse<number>) => {
                toast.success(res.Messages);
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        this.setState(
            {
                ...this.state,
                modal: {
                    showModal: false,
                    header: '',
                    body: '',
                    callBack: null,
                },
            },
            () => {
                this.syncSearch().then(async () => {
                    const payByWebChargeStationRequestList = await this.getPayByWebChargeStationList();
                    this.setState({ ...this.state, payByWebChargeStationRequestList });
                });
            },
        );
    };

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="title row align-items-content justify-content-between pb-3">
                    <div className="col-auto col-sm text-truncate pr-0">
                        <h1 className="text-truncate">{t('payByWeb.header')}</h1>
                    </div>
                    <Can I={Common.Actions.CAN_UPDATE} a={Common.Modules.PAY_BY_WEB}>
                        <div className="col-auto">
                            <div className="btn-list">
                                <button
                                    title={t('payByWeb.button.disabledPayByWeb')}
                                    type="button"
                                    id="disablePayByWeb"
                                    className="btn icon-btn pr-0 btn-outline-primary mr-3"
                                    disabled={this.state.checkedRecord.length === 0}
                                    onClick={() => {
                                        this.handleModal(
                                            t('payByWeb.message.disableConfirmMesage'),
                                            t('payByWeb.button.disabledPayByWeb'),
                                            () => this.updatePayByWebChargeStation(false),
                                        );
                                    }}
                                >
                                    <img
                                        className="icon"
                                        src={images.disabledredSVG}
                                        alt={t('payByWeb.button.disabledPayByWeb')}
                                        style={{
                                            top: '1px',
                                            left: '6px',
                                            width: '26px',
                                            height: '35px',
                                        }}
                                    />
                                </button>
                                <button
                                    title={t('payByWeb.button.enablePayByWeb')}
                                    type="button"
                                    id="enablePayByWeb"
                                    className="btn icon-btn pr-0 btn-outline-primary"
                                    disabled={this.state.checkedRecord.length === 0}
                                    onClick={async () => {
                                        this.handleModal(
                                            t('payByWeb.message.enableConfirmMesage'),
                                            t('payByWeb.button.enablePayByWeb'),
                                            () => this.updatePayByWebChargeStation(true),
                                        );
                                    }}
                                >
                                    <img
                                        className="icon"
                                        src={images.checkRedSVG}
                                        alt={t('payByWeb.button.disabledPayByWeb')}
                                        style={{
                                            top: '1px',
                                            left: '6px',
                                            width: '26px',
                                            height: '35px',
                                        }}
                                    />
                                </button>
                            </div>
                        </div>
                    </Can>
                </div>
                <div className="card-outer">
                    <div className="pt-3 px-3">
                        <form
                            noValidate
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSearch();
                            }}
                            autoComplete="off"
                        >
                            <div className="row">
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="search_evse_id"
                                        value={this.state.searchForm.search_evse_id}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t('payByWeb.placeholder.evse_id')}
                                        autoComplete="off"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="search_status"
                                        class="form-control"
                                        value={this.state.searchForm.search_status}
                                        isMulti={true}
                                        options={this.statusList}
                                        onChange={(values) => {
                                            this.handleChangeDropdown('search_status', values);
                                        }}
                                        getOptionLabel={(opt) => opt.label}
                                        getOptionValue={(opt) => opt.value}
                                        isClearable={true}
                                        placeholder={t('payByWeb.placeholder.status')}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="search_physical_reference"
                                        value={this.state.searchForm.search_physical_reference}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t('payByWeb.placeholder.physical_reference')}
                                        autoComplete="off"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="search_location_name"
                                        value={this.state.searchForm.search_location_name}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t('payByWeb.placeholder.location_name')}
                                        autoComplete="off"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="search_location_address"
                                        value={this.state.searchForm.search_location_address}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t('payByWeb.placeholder.location_address')}
                                        autoComplete="off"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-auto">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mr-2"
                                        title={t('payByWeb.button.search')}
                                    >
                                        <span>{t('payByWeb.button.search')}</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        title={t('payByWeb.button.reset')}
                                        onClick={this.handleReset}
                                    >
                                        <span>{t('payByWeb.button.reset')}</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <Table
                        columns={this.state.columns}
                        data={this.state.payByWebChargeStationRequestList}
                        rowsPerPage={this.state.rowsPerPage}
                        currentPage={this.state.currentPage}
                        totalCount={this.state.totalCount}
                        sortColumn={this.state.sortColumn}
                        sortOrder={this.state.sortOrder}
                        handlePageChange={this.handlePageChange}
                        handleSorting={this.handleSorting}
                        t={this.props.t}
                        isCheckboxGrid={true}
                        checkedRecord={this.state.checkedRecord}
                        setCheckedRecord={(data) => {
                            this.setState({ checkedRecord: data });
                        }}
                    />
                </div>
                <ConfirmBox
                    t={this.props.t}
                    closeModel={this.handleModal}
                    header={this.state.modal.header}
                    body={this.state.modal.body}
                    callBack={this.state.modal.callBack}
                    showModel={this.state.modal.showModal}
                />
                <Modal show={this.state.showManageUniqueCodeModal} onHide={() => this.closeManageUniqueCodeModal()}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('payByWeb.label.manageUniqueCode')}</Modal.Title>
                    </Modal.Header>
                    <Formik
                        enableReinitialize
                        initialValues={this.state.manageUniqueCodeForm}
                        onSubmit={this.onConfirmSaveUniqueCode}
                        validationSchema={ManageUniqueCodeValidationSchema(t)}
                    >
                        {(formik) => {
                            const { handleSubmit } = formik;
                            return (
                                <form onSubmit={handleSubmit} autoComplete="off">
                                    <Modal.Body>
                                        <Field
                                            name="unique_code"
                                            id="unique_code"
                                            autoComplete="off"
                                            placeholder={t('payByWeb.label.uniqueCode')}
                                            label={t('payByWeb.label.uniqueCode')}
                                            maxLength={10}
                                            component={ReactstrapInput}
                                        />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className="btn-block clearfix ModelBtn">
                                            <button
                                                type="submit"
                                                className="btn btn-primary mr-2 mb-2"
                                                title={t('payByWeb.button.submit')}
                                            >
                                                <span>{t('payByWeb.button.submit')}</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary mb-2"
                                                title={t('payByWeb.button.cancel')}
                                                onClick={this.closeManageUniqueCodeModal}
                                            >
                                                <span>{t('payByWeb.button.cancel')}</span>
                                            </button>
                                        </div>
                                    </Modal.Footer>
                                </form>
                            );
                        }}
                    </Formik>
                </Modal>
            </>
        );
    }
}
export default PayByWebGrid;
